import { AloftArea, AloftDate, AloftPrice, SubjectData, isDefined } from '@aloft/toolkit-shared';

import { CompSelectionProperty } from '../types.ts';

function toAloftArea(area?: { unitAmount: number; unit: 'sqft' | 'acre' }): AloftArea | undefined {
  return area ? AloftArea.fromNumber(area.unitAmount, area.unit) : undefined;
}

function toAloftDate(isoMonth?: string) {
  return isoMonth ? AloftDate.fromIsoString(`${isoMonth}-01`) : undefined;
}

function parseSalePrice(
  price?: AloftPrice | { $type: 'AloftPrice'; unitAmount: number; currency: 'usd' },
) {
  return price ? AloftPrice.schema.parse(price) : undefined;
}

export function useSubjectCraftsmanPropertyToCompSelectionProperty(
  subject: SubjectData,
  effectiveDate: AloftDate,
): CompSelectionProperty {
  const { improvements, site, transaction, propertyIdentification } = subject.editableData;
  const { listing } = subject.readonlyData.backupListingData ?? {};

  const yearBuilt = isDefined(improvements?.age)
    ? effectiveDate.getYear() - improvements.age
    : undefined;

  return {
    t: 'tk',
    id: 'subject',
    address: propertyIdentification.address,
    latitude: propertyIdentification.coordinates?.latitude,
    longitude: propertyIdentification.coordinates?.longitude,
    gla: toAloftArea(improvements?.gla),
    lotSize: toAloftArea(site.area),
    saleDate: toAloftDate(transaction.saleDate),
    contractDate: toAloftDate(transaction.contractDate),
    salePrice: parseSalePrice(transaction.price),
    listPrice: parseSalePrice(transaction.originalListPrice),
    yearBuilt,
    halfBaths: improvements?.halfBaths,
    fullBaths: improvements?.fullBaths,
    distanceToSubject: 0,
    cumulativeDaysOnMarket: transaction.daysOnMarket,
    bedrooms: listing?.BedroomsTotal,
    basement: listing?.BasementYN,
    garage: listing?.GarageYN,
    mlsStatus: listing?.MlsStatus,
    reo: listing?.SpecialListingConditions?.includes('REO'),
    shortSale: listing?.SpecialListingConditions?.includes('Short Sale'),
    garageCount: listing?.GarageSpaces,
    pool: listing?.PoolPrivateYN,
    propertyType: listing?.PropertySubType,
  };
}
